import { useExperimentFlag } from '../../../utils/useExperimentFlag';
import { useTranslation } from '../../../utils/useTranslation';
import { Typography } from '../../typography/Typography';
import { BusinessRegistrationHeaderProps } from './types';

export const BusinessRegistrationHeader = ({ typeSlot }: BusinessRegistrationHeaderProps) => {
    const t = useTranslation();
    const enableServiceRegistration =
        Number(useExperimentFlag('enable_service_registration')) === 1;

    return (
        <>
            <Typography
                variant="title2"
                weight="bold"
                pt={enableServiceRegistration ? 1 : 2}
                pb={2}
            >
                {t('Зарегистрироваться в Яндекс Ритме')}
            </Typography>
            {typeSlot ? (
                <Typography variant="body" pt={1}>
                    {t('Выберите тип аккаунта')}
                </Typography>
            ) : null}
            {typeSlot}
        </>
    );
};
